export default {
    'zh_CN': {
        'property.trim.id.label': '主键',
        'property.trim.id.holder': '请输入主键',
        
        
        'property.trim.id.required': '主键必填',
        'property.trim.areaId.label': '修剪区域',
        'property.trim.areaId.holder': '请输入修剪区域',
        
        
        'property.trim.areaId.required': '修剪区域必填',
        'property.trim.trimTime.label': '修剪时间',
        'property.trim.trimTime.holder': '请输入修剪时间',
        'property.trim.trimTime.required': '修剪时间必填',
        'property.trim.trimPeople.label': '修剪人',
        'property.trim.trimPeople.holder': '请输入修剪人',
        
        
        'property.trim.trimPeople.required': '修剪人必填',
        'property.trim.remark.label': '备注',
        'property.trim.remark.holder': '请输入备注',
        'property.trim.remark.max': '备注最多255个字符',
        
        'property.trim.remark.required': '备注必填',
        'property.trim.createTime.label': '创建日期',
        'property.trim.createTime.holder': '请输入创建日期',
        'property.trim.createTime.required': '创建日期必填',
        'property.trim.updateTime.label': '修改日期',
        'property.trim.updateTime.holder': '请输入修改日期',
        'property.trim.updateTime.required': '修改日期必填',
        'property.trim.isDelete.label': '是否删除',
        'property.trim.isDelete.holder': '请输入是否删除',
        
        
        'property.trim.isDelete.dictionary': ()=>[{value:0,label:'删除'}],
        'property.trim.isDelete.required': '是否删除必填'
    },
    'zh_TW': {
        'property.trim.id.label': '主键',
        'property.trim.id.holder': '請輸入主键',
        
        
        'property.trim.id.required': '主键必填',
        'property.trim.areaId.label': '修剪区域',
        'property.trim.areaId.holder': '請輸入修剪区域',
        
        
        'property.trim.areaId.required': '修剪区域必填',
        'property.trim.trimTime.label': '修剪时间',
        'property.trim.trimTime.holder': '請輸入修剪时间',
        
        
        'property.trim.trimTime.required': '修剪时间必填',
        'property.trim.trimPeople.label': '修剪人',
        'property.trim.trimPeople.holder': '請輸入修剪人',
        
        
        'property.trim.trimPeople.required': '修剪人必填',
        'property.trim.remark.label': '备注',
        'property.trim.remark.holder': '請輸入备注',
        
        
        'property.trim.remark.required': '备注必填',
        'property.trim.createTime.label': '创建日期',
        'property.trim.createTime.holder': '請輸入创建日期',
        
        
        'property.trim.createTime.required': '创建日期必填',
        'property.trim.updateTime.label': '修改日期',
        'property.trim.updateTime.holder': '請輸入修改日期',
        
        
        'property.trim.updateTime.required': '修改日期必填',
        'property.trim.isDelete.label': '是否删除',
        'property.trim.isDelete.holder': '請輸入是否删除',
        
        
        'property.trim.isDelete.required': '是否删除必填'
    },
    'en_US': {
        'property.trim.id.label': 'id',
        'property.trim.id.holder': 'Enter id',
        'property.trim.id.max': 'id max length: 主键',
        
        
        'property.trim.id.required': 'id required',
        'property.trim.areaId.label': 'areaId',
        'property.trim.areaId.holder': 'Enter areaId',
        'property.trim.areaId.max': 'areaId max length: 修剪区域',
        
        
        'property.trim.areaId.required': 'areaId required',
        'property.trim.trimTime.label': 'trimTime',
        'property.trim.trimTime.holder': 'Enter trimTime',
        'property.trim.trimTime.max': 'trimTime max length: 修剪时间',
        
        
        'property.trim.trimTime.required': 'trimTime required',
        'property.trim.trimPeople.label': 'trimPeople',
        'property.trim.trimPeople.holder': 'Enter trimPeople',
        'property.trim.trimPeople.max': 'trimPeople max length: 修剪人',
        
        
        'property.trim.trimPeople.required': 'trimPeople required',
        'property.trim.remark.label': 'remark',
        'property.trim.remark.holder': 'Enter remark',
        'property.trim.remark.max': 'remark max length: 备注',
        
        
        'property.trim.remark.required': 'remark required',
        'property.trim.createTime.label': 'createTime',
        'property.trim.createTime.holder': 'Enter createTime',
        'property.trim.createTime.max': 'createTime max length: 创建日期',
        
        
        'property.trim.createTime.required': 'createTime required',
        'property.trim.updateTime.label': 'updateTime',
        'property.trim.updateTime.holder': 'Enter updateTime',
        'property.trim.updateTime.max': 'updateTime max length: 修改日期',
        
        
        'property.trim.updateTime.required': 'updateTime required',
        'property.trim.isDelete.label': 'isDelete',
        'property.trim.isDelete.holder': 'Enter isDelete',
        'property.trim.isDelete.max': 'isDelete max length: 是否删除',
        
        
        'property.trim.isDelete.required': 'isDelete required'
    }
}
